import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Container, Row, Col, Card, ListGroup, Button, Image, Table } from "react-bootstrap";
import "./img.css";
import LatestUpdates from "./latestupdates";
import { FaFacebook, FaTiktok, FaYoutube, FaInstagram, FaArrowLeft, FaArrowRight } from "react-icons/fa";
import Footer from './footer';


const ContentSection = () => (
    <Col md={8}>
        <h2>UK Student Visa</h2><br /><br />

        <p>
            Comprising four countries, England, Northern Ireland, Scotland, and Wales,
            The United Kingdom is one of the best study destinations in the world with around 5,00,000
            international students enrolling each year. UK’s educational institutions consistently do
            well in world rankings. For an instant, the University of Oxford, University of Cambridge,
            UCL, Imperial College London, and 80 more UK universities have been ranked among the best by
            QS ranking agency this year. With the new immigration policy and introduction of 2-year post-study
            work rights, the UK is again becoming popular among Indian students. According to the UK government, last year saw a 63% increase in Indian students who chose to study in the UK!
        </p>
        <h4 className="fw-bold text-decoration-underline">Why Study in UK?</h4>
        <h4><b>Reasons to Join Institutes of UK</b></h4>
        <p>World-Class universities and colleges, internationally recognized degrees and diplomas,
            and 2-year post-study work rights make the UK ideal for students who want to take their
            careers to new heights. British institutions not only emphasize skill development, knowledge,
            and critical thinking but also encourage learners to be creative and independent in their lives.
            While studying in the UK, on the one hand, students can experience the richness of its culture
            and diversity, and on the other, they can improve their English language skills to the finest.</p>

        <ul>
            <li>UK educational institutions are known for maintaining the highest quality of education and have
                given over 130 Nobel Laureates to the world. The UK has achieved the first spot in “Best Countries
                for Education 2019” rankings by US News & World Report.</li>
            <li>UK universities are among the best in the world. 84 and 100 of them have been chosen by QS World University Rankings
                and THE World University Rankings respectively for the year 2020.</li>
            <li>UK universities and colleges offer a plethora of study programs in over 25 subject areas. You can choose your blend in
                several academic and vocational programs.</li>
            <li>Study Programs in the UK are generally shorter than courses of other top study destinations which helps in reducing
                overall tuition fees and accommodation costs.</li>
            <li>UK degrees and diplomas hold great value and are recognized by many reputed employers around the world.</li>
            <li>The new 2-year post-study work rights enable you to work in the UK after completing your study program.
                It is a great way to work and settle in the region.</li>
            <li>The UK is a cultural heritage. Studying in the UK gives you an opportunity to visit centuries-old castles and
                historical places and improve your English.</li>
        </ul>
        <br /><br />
        <h4 className="fw-bold text-decoration-underline">Requirements to UK student visa</h4>
        <h5><b>Eligibility Criteria</b></h5>
        <p>The UK offers an excellent opportunity to nearly half-a-million international students who come
            from around the world. Depending on the type of course you choose and age, you may have to apply
            for a Short-term study visa, Child student visa (Tier 4) or General student visa (Tier 4).
            Most likely, for an academic program, you will need to apply for a Tier for General student visa,
            for which the essential documents that you will need are</p>
        <ul>
            <li>an unconditional offer letter from a licensed Tier 4 sponsor</li>
            <li>evidence of funds to support yourself and pay for your course</li>
            <li>a valid passport</li>
            <li>confirmation of visa fees payment.</li>
            <li>payment slips</li>
            <li>certificate of English proficiency (IELTS) (if applicable case by case)</li>
            <li>Health Report</li>
            <li>Passport-size photographs</li>
            <li>result of tuberculosis test (if required)</li>
            <li>proof of age</li>
        </ul>
        <p>If your plans are long term that is you would like to work here too then you need to know the
            requirements of work here and after study, you could pursue what you are looking forward to
            providing your visa tenure permits you to do the same. Dependent work children also need a student visa.
            To avoid any delay students are advised to apply for the visa from their home country.</p>
        <br /><br />
        <motion.button
    initial={{ x: "-100vw", opacity: 0 }}
    animate={{ x: 0, opacity: 1 }}
    transition={{ type: "tween", duration: 0.6, ease: "easeOut" }}
    className="btn btn-danger btn-sm position-fixed bottom-0 stAAT-0 m-3"
    style={{ zIndex: 1050 }}
>
    <i className="bi bi-chat-left-text me-1"></i>
    <a 
        href="https://au.bajwaimmigration.com/book-appointment" 
        className="text-white text-decoration-none"
    >
        Consult Now
    </a>
</motion.button>

    </Col>
);


const Sidebar = () => (
    <Col md={3}>
          <Col md={4}>
                        <Card>
                            <Card.Header className="fw-bold">Latest Posts</Card.Header>
                            <ListGroup variant="flush">
                                <ListGroup.Item><Link to="/professional" className="dropdown-item"> <a href="" className="text-decoration-none">Professional Year</a> </Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/coursechange" className="dropdown-item"> <a href="" className="text-decoration-none">Admissions And Course Change </a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/skilledID" className="dropdown-item"> <a href="" className="text-decoration-none">   Skilled Independent Visa (Subclass 189)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/workregionalvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Work Regional Visa (Subclass 491)</a></Link></ListGroup.Item>
                                <ListGroup.Item><Link to="/nominatedvisa" className="dropdown-item"> <a href="" className="text-decoration-none">Skilled Nominated Visa (Subclass 190)</a></Link></ListGroup.Item>
                               <ListGroup.Item><a href="https://immi.homeaffairs.gov.au/visas/getting-a-visa/visa-listing/skilled-regional-191"className="dropdown-item text-decoration-none"style={{ color: "#22327f" }}target="_blank"rel="noopener noreferrer">Permanent Residence visa (Subclass 191)</a></ListGroup.Item>
                                {/* <ListGroup.Item><Link to="/regionalvisa" className="dropdown-item"><a href="" className="text-decoration-none">Skilled Regional Visa (Subclass 887)</a></Link></ListGroup.Item> */
                                <ListGroup.Item><Link to="/tempactivity" className="dropdown-item"><a href="" className="text-decoration-none">Temporary Activity Visa (Subclass 408)</a></Link></ListGroup.Item>
}
                            </ListGroup>
                        </Card>
                    </Col>

        {/* YouTube & Social Media Section */}
        <Card className="p-3 text-center mt-4"> {/* Added spacing between sidebar and card */}
            <Image src="./img/brand-logo.png" alt="Bajwa Immigration Logo" fluid className="mb-3" />

            <h6 className="fw-bold">Subscribe to our YouTube channel</h6>
            <Button variant="danger" className="mb-3"><a href="https://www.youtube.com/embed/uOGAB9oYets">SUBSCRIBE</a></Button>

            <h6 className="fw-bold">Book Consultation</h6>
            <Button variant="warning">BOOK CONSULTATION</Button>

            <h6 className="fw-bold mt-3">Like Us on Facebook !!</h6>
            <iframe
                src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FBajwaImmigration&tabs&width=340&height=130&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=true&appId"
                width="100%"
                height="130"
                style={{ border: "none", overflow: "hidden" }}
                scrolling="no"
                frameBorder="0"
                allowFullScreen
            ></iframe>

            <h6 className="fw-bold mt-3">We are also on:</h6>
            <div className="d-flex justify-content-center gap-3">
                <FaInstagram size={30} color="#C13584" />
                <FaTiktok size={30} color="#000" />
                <FaYoutube size={30} color="crimson" />
            </div>
        </Card>
    </Col>
);


const UKVisa = () => (
    <>
        <Container className="mt-4">
            {/* <HeroSection /> */}
            <Row className="mt-4 gap-4"> {/* Added gap-4 for spacing between content and sidebar */}
                <ContentSection />
                <Sidebar />

            </Row>
        </Container>
        <LatestUpdates />
        <Footer />
    </>
);

export default UKVisa;
